// extracted by mini-css-extract-plugin
export default {"loader":"Graphs_loader__UuWn+","spin":"Graphs_spin__t5ibV"};